import Vue from 'vue'
import Router from 'vue-router'
import RouterArray from './routers'
// import store from '../store'

Vue.use(Router)

let router = new Router({
  routes: RouterArray
})
// router.beforeEach((to, from, next) => {
//   // debugger
//   if (to.name === '' || to.name === 'Home') {
//     store.commit('showHomeHeader', false)
//   } else {
//     store.commit('showHomeHeader', true)
//   }
//   next()
// })

// 解决Loading chunk (\d)+ failed问题
router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g
  const isChunkLoadFailed = error.message.match(pattern)
  if (isChunkLoadFailed) {
    // 用路由的replace方法，并没有相当于F5刷新页面，失败的js文件并没有从新请求，会导致一直尝试replace页面导致死循环，而用 location.reload 方法，相当于触发F5刷新页面，虽然用户体验上来说会有刷新加载察觉，但不会导致页面卡死及死循环，从而曲线救国解决该问题
    location.reload()
    // const targetPath = $router.history.pending.fullPath;
    // $router.replace(targetPath);
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js